var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9293 3.05281C12.8686 2.98008 12.7935 2.92079 12.7087 2.87872C12.6238 2.83665 12.5312 2.81271 12.4366 2.80843C12.342 2.80416 12.2475 2.81964 12.1593 2.8539C12.071 2.88815 11.9908 2.94042 11.9239 3.00738C11.8569 3.07433 11.8046 3.15451 11.7704 3.24278C11.7361 3.33106 11.7206 3.42551 11.7249 3.52011C11.7292 3.6147 11.7531 3.70737 11.7952 3.7922C11.8373 3.87703 11.8966 3.95216 11.9693 4.01281L16.8672 8.91648H0.677763C0.502997 8.92576 0.338446 9.00171 0.218017 9.1287C0.0975877 9.25569 0.0304565 9.42403 0.0304565 9.59904C0.0304565 9.77406 0.0975877 9.9424 0.218017 10.0694C0.338446 10.1964 0.502997 10.2723 0.677763 10.2816H16.8672L11.9616 15.1795C11.8381 15.3088 11.7692 15.4807 11.7692 15.6595C11.7692 15.8383 11.8381 16.0102 11.9616 16.1395C12.0246 16.2027 12.0994 16.2528 12.1817 16.287C12.2641 16.3212 12.3524 16.3388 12.4416 16.3388C12.5308 16.3388 12.6191 16.3212 12.7015 16.287C12.7838 16.2528 12.8586 16.2027 12.9216 16.1395L18.9888 10.0723C19.0534 10.0102 19.1048 9.93562 19.1398 9.85314C19.1749 9.77066 19.193 9.68196 19.193 9.59233C19.193 9.50269 19.1749 9.41399 19.1398 9.33151C19.1048 9.24903 19.0534 9.17448 18.9888 9.11233L12.9293 3.05281Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward);
export default __webpack_public_path__ + "static/media/arrowForward.7e37b381.svg";
export { ForwardRef as ReactComponent };